import React from 'react';
import { Component } from 'react';
import * as THREE from "three";
import { Scene, PerspectiveCamera, WebGLRenderer, AnimationMixer, Object3D, AnimationClip } from "three";
import { CSS2DRenderer } from 'three/examples/jsm/renderers/CSS2DRenderer';
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import DataSevice from '../../../services/dataSevice';
import { WrapperDataModel } from '../../../models/wrapperDataModel';
import Growl from '../../../common/components/growl/growl'
import * as HelperFunctions from '../../../common/helperFunctions';
import * as Constants from '../../../common/constants';
import { connect } from 'react-redux';
import { TagType } from '../../../common/enums';
import { TagModel } from '../../../models/tagModel';
import TWEEN from '@tweenjs/tween.js';
import ScenePopupComponent from '../../navigation/scenePopup.Component';
import BarComponent from '../../common/barChart.Component';
import axios from 'axios';

interface IProps {
  history?: any,
  lang: string
}

interface IState {
  isLoading: boolean;
  loadingPercent: number;
  allData: Array<WrapperDataModel>;
  isZoomIn: boolean;
  isDataUpdated: boolean;
  oldDataTags: Array<TagModel>;
  isPopupVisivle: boolean;
  popupContent: any;
  popupTitle: any;
}

class MainSceneComponent extends Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      isLoading: true,
      loadingPercent: 0,
      allData: new Array<WrapperDataModel>(0),
      isZoomIn: false,
      isDataUpdated: false,
      oldDataTags: new Array<TagModel>(0),
      popupContent: null,
      popupTitle: null,
      isPopupVisivle: false
    }
  }

  container: any;
  scene: Scene = new Scene();
  camera: PerspectiveCamera = new PerspectiveCamera(40, window.innerWidth / window.innerHeight, 50, 35000);
  renderer: WebGLRenderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
  labelRenderer: CSS2DRenderer = new CSS2DRenderer();
  weatherStation = React.createRef<HTMLDivElement>();
  common = React.createRef<HTMLDivElement>();
  controls: any;
  loadingManager: any;
  animationFrame: any;
  dataService = new DataSevice();
  interval: any;
  growl: any;
  boxSize: number = 0;
  mixer: AnimationMixer = new AnimationMixer(new Object3D());
  clock = new THREE.Clock();
  animations: Array<AnimationClip> = new Array<AnimationClip>(0);
  mouse: THREE.Vector2 = new THREE.Vector2();
  clickableObjects: Array<Object3D> = new Array<Object3D>(0);
  currentIntersectionObject: any;
  pulsatingDot = React.createRef<HTMLDivElement>();
  currentIntersectionObjectsGroup: Array<any> = new Array<any>(0);

  componentDidMount() {
    this.initLoading();
    this.initScene();
    this.initObjects();
    this.animate();
    window.addEventListener("resize", this.onWindowResize, false);
    window.addEventListener('wheel', this.onCameraZoom, true);
    window.addEventListener('touchmove', this.onCameraZoom, true);

    window.addEventListener('mousemove', this.onDocumentMouseMove, false);
    window.addEventListener('click', this.onDocumentMouseClick, false);
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.animationFrame);
    clearInterval(this.interval);
    //this.resourceTracker.dispose();
    this.onDestroy();

    window.removeEventListener('wheel', this.onCameraZoom, true);
    window.removeEventListener('touchmove', this.onCameraZoom, true);
    window.removeEventListener("resize", this.onWindowResize, false);

    window.removeEventListener('mousemove', this.onDocumentMouseMove, false);
    window.removeEventListener('click', this.onDocumentMouseClick, false);
  }

  initLoading = () => {
    this.loadingManager = new THREE.LoadingManager(
      () => {
        const loadingScreen = document.getElementById('loading-screen');
        if (loadingScreen) loadingScreen.classList.add('fade-out');
        if (loadingScreen) loadingScreen.addEventListener('transitionend', this.onTransitionEnd);
      },
      (url, itemsLoaded, itemsTotal) => {
        this.setState({ loadingPercent: Math.round(itemsLoaded / itemsTotal * 100) });
      },
      (url) => {
        console.log('There was an error loading ' + url);
      }
    );
  }

  onTransitionEnd = (event: any) => {
    this.setState({ isLoading: false });
    event.target.removeEventListener('transitionend', event.target);
  }

  //TODO: get pulsating dot object separatetly, not from the array
  removePulsatingDotFromScene = (objectName: string) => {
    let objectInScene = this.scene.getObjectByName(objectName);
    if (objectInScene) {
      this.scene.remove(objectInScene);

      let greenDot = this.scene.getObjectByName(objectName + 'GreenDot');
      if (greenDot)
        this.scene.remove(greenDot);

      let firstDot = this.scene.getObjectByName(objectName + 'FirstDot');
      if (firstDot)
        this.scene.remove(firstDot);

      let secondDot = this.scene.getObjectByName(objectName + 'SecondDot');
      if (secondDot)
        this.scene.remove(secondDot);
    }
  }

  initScene = () => {
    // Scene        
    //this.scene.background = new THREE.Color(0xe8f9fc);

    // var axesHelper = new THREE.AxesHelper(20000);
    // this.scene.add(axesHelper);

    // Camera
    this.camera.position.x = -1000; // -2000
    this.camera.position.y = 10000; // 20000
    this.camera.position.z = -1500; // 4000

    // Renderer    
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.autoClear = false;
    this.renderer.setClearColor(0x000000, 0.0);
    // this.renderer.shadowMap.enabled = true;
    // this.renderer.shadowMap.type = THREE.PCFShadowMap;
    this.container.appendChild(this.renderer.domElement);

    this.labelRenderer.setSize(window.innerWidth, window.innerHeight);
    this.labelRenderer.domElement.style.position = 'absolute';
    this.labelRenderer.domElement.style.top = "0";
    this.container.appendChild(this.labelRenderer.domElement)
    // Controls
    this.controls = new OrbitControls(this.camera, this.container);

    // Lights
    const light1 = new THREE.DirectionalLight(0xffffff, 1);
    light1.position.set(-4000, 4000, -4000); // (-10000, 10000, 10000);
    // light1.castShadow = true;
    // light1.shadow.bias = 0.001;
    // light1.shadow.mapSize.width = 8192;
    // light1.shadow.mapSize.height = 8192;
    // light1.shadow.radius = 3;
    this.scene.add(light1);
    // var light1Helper = new THREE.DirectionalLightHelper(light1, 50);
    // this.scene.add(light1Helper);

    const cam = light1.shadow.camera;
    cam.near = 30;
    cam.far = 15000;
    cam.left = -5000;
    cam.right = 5000;
    cam.top = 5000;
    cam.bottom = -5000;
    // const cameraHelper = new THREE.CameraHelper(cam);
    // this.scene.add(cameraHelper);

    var light2 = new THREE.AmbientLight(0xffffff, 2);
    light2.position.set(100, 100, 100);
    this.scene.add(light2);

    // var pointLight = new THREE.PointLight(0xff0000, 1, 2000);
    // pointLight.position.set(1000, 1000, 1000);
    // this.scene.add(pointLight);

    // var light3 = new THREE.AmbientLight(0xffffff, 1);
    // light3.position.set(-1000, -1000, -1000);
    // this.scene.add(light3);
  }

  initObjects = () => {
    const gltfLoader = new GLTFLoader(this.loadingManager);
    let dracoloader = new DRACOLoader();
    dracoloader.setDecoderPath(Constants.dracoJS)
    gltfLoader.setDRACOLoader(dracoloader);
    gltfLoader.load(Constants.modelMainHall, (gltf: any) => {
      const root = gltf.scene;
      this.scene.add(root);

      // var boxHelper = new THREE.BoxHelper(root);
      // this.scene.add(boxHelper);

      //console.log(HelperFunctions.dumpObject(root).join('\n'));
      this.mixer = new THREE.AnimationMixer(root);
      let oldAnimationsArray: Array<AnimationClip> = gltf.animations;
      let newAnimationsArray: Array<AnimationClip> = new Array<AnimationClip>(0);

      oldAnimationsArray.forEach(r => {
        let animationTracks = r.tracks;
        let allAnimations: AnimationClip = new AnimationClip("All_Animations", r.duration, animationTracks);
        newAnimationsArray.push(allAnimations);
      });

      this.animations = newAnimationsArray;

      let allAnimatios = THREE.AnimationClip.findByName(newAnimationsArray, "All_Animations");
      let animation = this.mixer.clipAction(allAnimatios);
      animation.play();

      root.traverse((obj: any) => {
        if (obj.castShadow !== undefined) {
          obj.castShadow = true;
          obj.receiveShadow = true;
        }
      });

      // root.traverse((obj: any) => {
      //   if (obj.type === "Mesh") {
      //     obj.material.opacity = 0.5;
      //     obj.material.transparent = true;
      //     obj.material.side = THREE.DoubleSide;
      //   }
      // });

      // root.traverse((obj: any) => {
      //   if (obj.type === "Mesh") {
      //     obj.material.opacity = 0.5;
      //     obj.material.transparent = true;
      //     obj.material.side = THREE.FrontSide;
      //   }
      // });

      const box = new THREE.Box3().setFromObject(root);

      this.boxSize = box.getSize(new THREE.Vector3()).length();
      const boxCenter = box.getCenter(new THREE.Vector3());

      // set the camera to frame the box
      // this.frameArea(this.boxSize * 0.5, this.boxSize, boxCenter);

      // update the Trackball controls to handle the new size
      this.controls.maxPolarAngle = Math.PI / 2.3;
      this.controls.minPolarAngle = Math.PI / 4;
      this.controls.maxDistance = this.boxSize * 1.5;
      this.controls.minDistance = this.boxSize * 0.3;
      this.controls.target.copy(boxCenter);
      this.controls.enableDamping = true;
      this.controls.dampingFactor = 0.05;
      // this.controls.rotateSpeed = 0.3;
      // this.controls.zoomSpeed = 0.7;
      this.controls.update();
      this.processData();
      //this.addClickableObjects();
      //this.getData();

    });
  }

  addClickableObjects = () => {
    this.scene.traverse(c => {
      if (Constants.mainHallScene_SelectableObjectArray.some(o => c.name.startsWith(o))) {
        this.clickableObjects.push(c);
      }
    })
  }

  getData = () => {
    this.setState({ isDataUpdated: false })
    this.dataService.getAllTagsData().then(
      (data: any) => {
        // this.processData(data);
      }
    ).catch(
      (error: any) => {
        this.growl.show({ severity: 'error', summary: error.message });
      });
  }

  processData = () => {
    axios.get('/assets/config.json') // JSON File Path
      .then(res => {
        if (res.data) {
          let mainhall = res.data.scenes.find(r => r['mainHallScene']).mainHallScene;
          if (mainhall) {
            let points = mainhall.interactivePoints;
            for (let point of points) {
              if (!point.visibleAfterAnimation) {
                HelperFunctions.addInteractivePoints(point.position, point.pointName,
                  point.route !== null ? () => this.onNavigationCLick(point.route) : this[point.method], this.scene);
              }
            }
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  animate = () => {
    if (this.mixer) {
      this.mixer.update(this.clock.getDelta());
    }
    this.animationFrame = requestAnimationFrame(this.animate);
    this.controls.update();
    TWEEN.update();
    //this.checkClickableIntersections();
    this.renderer.render(this.scene, this.camera);
    this.labelRenderer.render(this.scene, this.camera);
  }

  onDocumentMouseMove = (event: any) => {
    this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    this.mouse.y = - (event.clientY / window.innerHeight) * 2 + 1;
  }

  //Code for interactions commented
  onDocumentMouseClick = (event) => {
    event.preventDefault();

    // this.raycaster.setFromCamera(this.mouse, this.camera)
    // let intersections = this.raycaster.intersectObjects(this.clickableObjects);

    // let isns = this.raycaster.intersectObjects(this.scene.children, true);
    // if (isns && isns.length > 0) {
    //   console.log(isns)
    // }

    // let intersection = (intersections.length) > 0 ? intersections[0] : null;
    // if (intersection && intersection.object &&
    //   Constants.mainHallScene_ClickableObjectArray.some(o => (intersection && intersection.object.name.startsWith(o)))
    // ) {
    //   //Enter etrance
    //   if (Constants.mainHallScene_AssemblyLine.some(o => (intersection && intersection.object.name.startsWith(o))))
    //     this.onNavigationCLick("/assembly-line");
    // }
  }

  onWindowResize = () => {
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.labelRenderer.setSize(window.innerWidth, window.innerHeight);
  }

  onCameraZoom = () => {
    let zoomValue = this.camera.position.length();

    if (zoomValue < this.boxSize * .7) {
      if (!this.state.isZoomIn) {
        this.setState({
          isZoomIn: true
        });
      }
    } else {
      if (this.state.isZoomIn) {
        this.setState({
          isZoomIn: false
        });
      }
    }
  }

  onNavigationCLick = (path: string) => {
    this.props.history.push(path);
  }

  onDestroy = () => {
    HelperFunctions.disposeResource(this.scene);
  }

  addMouseHoverEffectToObjectArray = (objectsArray) => {
    objectsArray.forEach(o => {
      let currentObj: any = this.scene.getObjectByName(o);
      if (currentObj) {
        this.currentIntersectionObjectsGroup.push(currentObj);

        let objMat = currentObj.material.clone();
        objMat.emissive.setHex("0x444444");

        currentObj.material = objMat;
      }
    });
  }

  removeMouseHoverEffectFromObjectArray = () => {
    this.currentIntersectionObjectsGroup.forEach(o => {
      o.material.emissive.setHex("0x000000");
    });

    this.currentIntersectionObjectsGroup = new Array<any>(0);
  }

  openBarPopup = (tagNumber: number) => {
    var barChart = <BarComponent tagNumber={tagNumber} lang={this.props.lang} width={800} height={400} paginator={true} popupChart={true} />;
    var title = (
      <div style={{ marginBottom: 10, paddingTop: 5 }}>{HelperFunctions.getEnumLabel(tagNumber, TagType, true)}</div>);
    this.setState({ isPopupVisivle: true, popupContent: barChart, popupTitle: title })
  }

  handleCancelPopupButton = () => {
    this.setState({ isPopupVisivle: false })
  }

  render() {
    return (
      <>
        <Growl ref={(el: any) => this.growl = el} />

        {this.state.isLoading ?
          <section id="loading-screen">
            <div id="loader"></div>
            <div id="loader-percent">{this.state.loadingPercent} %</div>
          </section> : null}

        <div ref={ref => (this.container = ref)}>
        </div>
        <ScenePopupComponent
          isVisible={this.state.isPopupVisivle}
          content={this.state.popupContent}
          handleCancelButton={this.handleCancelPopupButton}
          title={this.state.popupTitle} />
      </>
    );
  }

}

const mapsStateToProps = (state: any) => {
  return {
    lang: state.common.lang,
    // animationState: state.common.animationState
  };
}

export default connect(mapsStateToProps, null)(MainSceneComponent);
